// extracted by mini-css-extract-plugin
export var apple = "tree-module--apple--2XRi6";
export var branch = "tree-module--branch--2iad0";
export var dash = "tree-module--dash--4yad7";
export var fruit = "tree-module--fruit--Qdpeu";
export var leaf = "tree-module--leaf--mZQRX";